import {
  OVERVIEW_ACTIVE,
  OVERVIEW_INACTIVE,
  FOLDER_ACTIVE,
  FOLDER_INACTIVE,
  PAYMENT_ACTIVE,
  PAYMENT_INACTIVE,
  NOTIFICATION_ACTIVE,
  NOTIFICATION_INACTIVE,
  SETTING_ACTIVE,
  SETTING_INACTIVE,
  PANEL_ACTIVE,
  PANEL_INACTIVE,
  OFFICIAL_ACTIVE,
  OFFICIAL_INACTIVE,
  CRM_ACTIVE,
  CRM,
} from "../../../../assets";

export const AdminSidebarRoute = [
  {
    title: "Overview",
    activeIcon: OVERVIEW_ACTIVE,
    inactiveIcon: OVERVIEW_INACTIVE,
    path: "/admin/overview",
  },
  {
    title: "Case Folders",
    activeIcon: FOLDER_ACTIVE,
    inactiveIcon: FOLDER_INACTIVE,
    path: "/admin/case-folders",
  },
  {
    title: "Users",
    activeIcon: PANEL_ACTIVE,
    inactiveIcon: PANEL_INACTIVE,
    path: "/admin/users",
  },
  {
    title: "Entities",
    activeIcon: SETTING_ACTIVE,
    inactiveIcon: SETTING_INACTIVE,
    path: "/admin/entities",
  },
  {
    title: "Manage Officials",
    activeIcon: OFFICIAL_ACTIVE,
    inactiveIcon: OFFICIAL_INACTIVE,
    path: "/admin/manage-officials",
  },
  {
    title: "Cause Lists",
    activeIcon: PAYMENT_ACTIVE,
    inactiveIcon: PAYMENT_INACTIVE,
    path: "/admin/cause-lists",
  },
  {
    title: "CRM",
    activeIcon: CRM_ACTIVE,
    inactiveIcon: CRM,
    path: "/admin/crm",
  },

  // {
  //   title: "Notification",
  //   activeIcon: NOTIFICATION_ACTIVE,
  //   inactiveIcon: NOTIFICATION_INACTIVE,
  //   path: "/admin/notification",
  // },
  {
    title: "Setting",
    activeIcon: SETTING_ACTIVE,
    inactiveIcon: SETTING_INACTIVE,
    path: "/admin/setting",
  },
];
